import React from 'react';
import PropTypes from 'prop-types';

import PureComponent from '../pure';
import Tree from '../Tree/Tree';
import sAction from 'sAction';

export default class ListViewTableTree extends PureComponent {
    change(id) {
        const data = this.props.data;
        const way = this.props.way;

        let ids = [];
        sAction.getSubCatFromTree(data.tree, id, false, ids);

        if (ids.length == 0) {
            ids = null;
        }
        sAction.dataSet(way+'/listViewTree/activeCategory', id);
        sAction.dataSet(way + '/defaultFilter/tree/parentId', ids);
        sAction.reloadList(0, 1, way);
    }

    render() {
        let activeCategory = this.props.data.activeCategory;
        if (activeCategory == null) {
            activeCategory = sAction.getStorage('listViewTreeActiveCategory') ?? {};
            activeCategory = activeCategory[sAction.getViewName() + this.props.data.module] ?? '';
        }

        return (
            <div className="listViewTableTree">
                <Tree
                    header={sAction.translate('LBL_TREE_CATEGORY')}
                    data={this.props.data.tree.toJS()}
                    selected={activeCategory}
                    onSelectGroup={(id) => this.change(id)}
                    openLevel={1}
                />
            </div>
        );
    }
}

ListViewTableTree.propTypes = {
    data: PropTypes.shape({
        activeCategory: PropTypes.string,
        module: PropTypes.string,
        tree: PropTypes.shape({
            toJS: PropTypes.func,
        }),
    }),
    way: PropTypes.string,
};

